import styled from '@emotion/styled';
import Page from '../../layout/Page';
import First from './first';
import Second from './second';
import Third from './third';
import Fourth from './fourth';


const App:React.FC<any> = () => {
  const handleSubscribe = () => {
    window.location.href="/subscribe"
  }

  const handleProduct = () => {
    window.location.href="/product"
  }

  return(
    <>
    <Page disable>
      <Container>
        <ImgContainer>
          <Img src="/images/klikkie/main/print.png"/>
        </ImgContainer>
        {/* <Title>모든 인화, <span>&nbsp; 포티페타로 고민없이</span></Title>
        <First />
        <Second />
        <Third />
        <Fourth />
        <ButtonContainer
          className="top"
          onClick={handleSubscribe}
        >
          인화구독 더 알아보기
        </ButtonContainer>
        <ButtonContainer
        className="bottom"
          onClick={handleProduct}
        >
          앨범 알아보기
        </ButtonContainer> */}
      </Container>
    </Page>
    </>
  )
}

export default App;

const Container = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding-top: 120px;
`;

const Title = styled.div`
  display: flex;
  width: 100%;
  height: 70px;
  background-color: #f0Ede7;
  font-size: 18px;
  align-items: center;
  justify-content: center;

  span {
    font-weight: 700;
  }
`;


const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 75px;

  color: black;
  font-size: 15px;
  font-weight: 500;
  &.top {
    background-color: #ede3cd;
  }
  &.bottom {
    background-color: #e5e0b7;
  }
`;

const ImgContainer = styled.div`
  width: 100%;
`;

const Img = styled.img`
  width: 100%;
`